
import ForgotPasswordPage from "../components/ForgotPassword/ForgotPasswordPage.vue";
import ForgotPassStepUserName from "../components/ForgotPassword/ForgotPassStepUserName.vue";
import ForgotPassStepSelectAccount from "../components/ForgotPassword/ForgotPassStepSelectAccount.vue";
import ForgotPassStepSelectSecureMethod from "../components/ForgotPassword/ForgotPassStepSelectSecureMethod.vue";
import ForgotPassStepConfirmSecure from "../components/ForgotPassword/ForgotPassStepConfirmSecure.vue";
import ForgotPassStepPassword from "../components/ForgotPassword/ForgotPassStepPassword.vue";

export default [
    {
        path: "/forgotpass",
        component: ForgotPasswordPage,
        meta: { layout: "default", title: 'Quên mật khẩu' },
        name: "forgotpass",
        children: [
          {
            path: "",
            component: ForgotPassStepUserName,
            name: "forgotpassdefault",
          },
          {
            path: "username",
            component: ForgotPassStepUserName,
            name: "forgotpassusername",
          },
          {
            path: "selectaccount",
            component: ForgotPassStepSelectAccount,
            name: "forgotpassselectaccount",
          },
          {
            path: "selectsecure",
            component: ForgotPassStepSelectSecureMethod,
            name: "forgotpassselectsecure",
          },
          {
            path: "confirmsecure",
            component: ForgotPassStepConfirmSecure,
            name: "forgotpassconfirmsecure",
          },
          {
            path: "newpassword",
            component: ForgotPassStepPassword,
            name: "forgotpassnewpassword",
          },
        ],
      }
];
